// assets
import { BarChartOutlined, PieChartOutlined, SunOutlined } from '@ant-design/icons';

// icons
const icons = {
  BarChartOutlined,
  PieChartOutlined,
  SunOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const report = {
  id: 'group-report',
  title: '발전량 통계',
  type: 'group',
  admin: false,
  children: [
    {
      id: 'report',
      title: '보고서',
      type: 'item',
      url: '/report/default',
      icon: icons.BarChartOutlined,
      breadcrumbs: false
    },

    {
      id: 'report-monthly',
      title: '월간보고서',
      type: 'item',
      url: '/report/monthly',
      icon: icons.PieChartOutlined,
      breadcrumbs: false
    },

    {
      id: 'report-weather',
      title: '기상관측보고서',
      type: 'item',
      url: '/report/weather',
      icon: icons.SunOutlined,
      breadcrumbs: false
    }
  ]
};

export default report;
